const combatReducer = (state = '0', action: any) => {
    switch (action.type) {
        case 'SET_COMBAT':
            return action.id;
        case 'EMPTY_COMBAT':
            return '0';
        default:
            return state;
    }
};

export default combatReducer;
